import { createChoicePreference, createSwitchPreference } from './storedPreference';

// #928 (epic #934): how things are displayed, chosen by the reader and kept in this browser.

export type MonographView = 'cards' | 'sheet';
export const MONOGRAPH_VIEWS: readonly MonographView[] = ['cards', 'sheet'];

/** Which layout a Monograph opens in: Cards (the default, #929) or Sheet (#930). */
export const monographViewPreference = createChoicePreference<MonographView>(
  'peruselab.monograph.view',
  MONOGRAPH_VIEWS,
  'cards'
);

/** #931: the unit temperatures are read in on a property's evidence view -- °C by default. */
export const TEMPERATURE_UNITS = ['Cel', '[degF]', 'K'] as const;
export type TemperatureUnit = (typeof TEMPERATURE_UNITS)[number];
export const temperatureUnitPreference = createChoicePreference<TemperatureUnit>(
  'peruselab.units.temperature',
  TEMPERATURE_UNITS,
  'Cel'
);

/** #1110 (P6): the Structure info panel opens by itself when a new problem appears -- on by default. */
export const structureInfoAutoOpenPreference = createSwitchPreference('peruselab.structureInfo.autoOpen', true);

/** #1127: the Bonds group's Special bonds leaf stays as the reader left it -- open or folded. */
export const specialBondsOpenPreference = createSwitchPreference('peruselab.rail.specialBonds.open', false);

/** #1127: the special bond last chosen, kept on the main Bonds grid; '' until one has been. */
export const SPECIAL_BOND_KEYS = ['', 'quadruple', 'quintuple', 'sextuple', 'hapto', 'agostic'] as const;
export type SpecialBondKey = (typeof SPECIAL_BOND_KEYS)[number];
export const lastSpecialBondPreference = createChoicePreference<SpecialBondKey>(
  'peruselab.rail.specialBonds.last',
  SPECIAL_BOND_KEYS,
  ''
);
